import React from 'react';
import { AutoComplete } from 'antd';
import { AutoCompleteProps as AutoCompleteCopyProps } from 'antd/lib/auto-complete';

export type AutoCompleteProps = AutoCompleteCopyProps;

const ProAutoComplete: React.FC<AutoCompleteProps> = React.forwardRef<
  any,
  AutoCompleteProps
>((props, ref) => {
  return <AutoComplete ref={ref} {...props} />;
});

export default ProAutoComplete;
